//load mousetrap
let Mousetrap = require('mousetrap');

//focus on dealer locator
Mousetrap.bind(['s', '/'], function () {
    document.querySelector('#dealerLocator')?.focus();
    return false;
});
